var shop = shop || {};
shop.models = {};

function NewsletterModel() {
    var self = this;

    self.Email = ko.observable();
    self.FirstName = ko.observable();
    self.LastName = ko.observable();
    self.SalutationId = ko.observable();
    self.TitleId = ko.observable();
    self.UserHasNewsletter = ko.observable();
    self.GoogleRecaptchaCode = ko.observable();

    self.Saved = ko.observable(false);
    self.Loading = ko.observable(false);

    self.Errors = ko.observableArray();
}

function ContactModel() {
    var self = this;

    self.SalutationId = ko.observable();
    self.TitleId = ko.observable();
    self.Firstname = ko.observable().extend({required: true});
    self.Lastname = ko.observable().extend({required: true});
    self.Company = ko.observable();
    self.Email = ko.observable().extend({required: true, email: true});
    self.Street = ko.observable().extend({required: true});
    self.ZipCode = ko.observable().extend({required: true});
    self.Country = ko.observable().extend({required: true});
    self.City = ko.observable().extend({required: true});
    self.Phone = ko.observable().extend({required: true});
    self.Fax = ko.observable();
    self.Request = ko.observable().extend({required: true});
    self.GoogleRecaptchaCode = ko.observable();

    self.SendingRequest = ko.observable(false);
    self.Errors = ko.observableArray();

    //subData
    self.FirstNameHasError = ko.observable(false);
    self.LastNameHasError = ko.observable(false);
    self.PhoneHasError = ko.observable(false);
    self.FaxHasError = ko.observable(false);
    self.EmailHasError = ko.observable(false);
    self.StreetHasError = ko.observable(false);
    self.CityHasError = ko.observable(false);
    self.ZipCodeHasError = ko.observable(false);
    self.CountryHasError = ko.observable(false);

    //computed
    self.FirstNameProxy = ko.computed({
        read: function () {
            return self.Firstname();
        },
        write: function (newFirstName) {
            if (newFirstName.length <= 35) {
                self.Firstname(newFirstName);
                self.FirstNameHasError(false);
            } else {
                self.FirstNameHasError(true);
                self.FirstNameProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.LastNameProxy = ko.computed({
        read: function () {
            return self.Lastname();
        },
        write: function (newLastName) {
            if (newLastName.length <= 35) {
                self.Lastname(newLastName);
                self.LastNameHasError(false);
            } else {
                self.LastNameHasError(true);
                self.LastNameProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.PhoneProxy = ko.computed({
        read: function () {
            return self.Phone();
        },
        write: function (newPhone) {
            if (newPhone.length <= 19) {
                self.Phone(newPhone);
                self.PhoneHasError(false);
            } else {
                self.PhoneHasError(true);
                self.PhoneProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.FaxProxy = ko.computed({
        read: function () {
            return self.Fax();
        },
        write: function (newFax) {
            if (newFax.length <= 15) {
                self.Fax(newFax);
                self.FaxHasError(false);
            } else {
                self.FaxHasError(true);
                self.FaxProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.EmailProxy = ko.computed({
        read: function () {
            return self.Email();
        },
        write: function (newEmail) {
            if (newEmail.length <= 50) {
                self.Email(newEmail);
                self.EmailHasError(false);
            } else {
                self.EmailHasError(true);
                self.EmailProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.StreetProxy = ko.computed({
        read: function () {
            return self.Street();
        },
        write: function (newStreet) {
            if (newStreet.length <= 35) {
                self.Street(newStreet);
                self.StreetHasError(false);
            } else {
                self.StreetHasError(true);
                self.StreetProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.CityProxy = ko.computed({
        read: function () {
            return self.City();
        },
        write: function (newCity) {
            if (newCity.length <= 30) {
                self.City(newCity);
                self.CityHasError(false);
            } else {
                self.CityHasError(true);
                self.CityProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });
    self.ZipCodeProxy = ko.computed({
        read: function () {
            return self.ZipCode();
        },
        write: function (newZipCode) {
            if (newZipCode.length <= 9) {
                self.ZipCode(newZipCode);
                self.ZipCodeHasError(false);
            } else {
                self.ZipCodeHasError(true);
                self.ZipCodeProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: self
    });

    //functions
    self.PopulateContactModel = function (jsonData) {
        if (jsonData) {
            self.Country(jsonData.Country);
            self.Company(jsonData.Company);
            self.Firstname(jsonData.FirstName);
            self.Lastname(jsonData.LastName);
            self.Street(jsonData.Street);
            self.ZipCode(jsonData.ZipCode);
            self.City(jsonData.City);
            self.Phone(jsonData.Phone);
            self.Email(jsonData.Email);
            self.Fax(jsonData.Fax);
            self.SalutationId(jsonData.SalutationId);
        }
    };

    self.IsValid = function () {
        var valid = true;
        var models = [
            self.Firstname,
            self.Lastname,
            self.Street,
            self.ZipCode,
            self.City,
            self.Phone,
            self.Email,
            self.Request,
            self.Country
        ];

        for (var i = 0; i < models.length; i++) {
            models[i].validate(models[i]());
            if (models[i].hasError()) {
                valid = false;
            }
        }
        return valid;
    };
}

var AccessPointModel = function () {
    var that = this;

    that.Descriptor = "shop.ordermodels.AccessPointModel";
    //baseData
    that.ConsigneeName = ko.observable('');
    that.APName = ko.observable().extend({required: true});
    that.APDetails = ko.observable('');
    that.APStreet = ko.observable('');
    that.APZip = ko.observable('');
    that.APCity = ko.observable('');
    that.APCountry = ko.observable('');
    that.APCountryId = ko.observable('');
    that.ConsigneeEmail = ko.observable('');
    that.ConsigneeMobile = ko.observable('');
    that.APCountryCode = ko.observable('');
    that.APID = ko.observable('');
    that.ConsigneeCountryCode = ko.observable('');
    that.ConsigneeStreet = ko.observable('');
    that.ConsigneeCity = ko.observable('');
    that.ConsigneePhoneNumber = ko.observable('');

};

var AddressModel = function (pageModelHndl) {
    var that = this;

    that.Descriptor = "shop.models.AddressModel";
    //baseData
    that.AddressId = ko.observable(undefined);
    that.CountryId = ko.observable().extend({required: true});
    that.Country = ko.observable('');
    that.StateProvinceCode = ko.observable('').extend({
        required: {
            params: true,
            onlyIf: function() {
                return countryHasStateProvinceCode(that.CountryId());
            }
        }
    });
    that.SalutationId = ko.observable();
    that.Salutation = ko.observable('');
    that.Company = ko.observable('');
    that.FirstName = ko.observable('').extend({required: true});
    that.LastName = ko.observable('').extend({required: true});
    that.Street = ko.observable('').extend({required: true});
    that.ZipCode = ko.observable('').extend({required: true});
    that.City = ko.observable('').extend({required: true});
    that.VatId = ko.observable('');
    that.ISO = ko.observable('');
    that.CMwSt = ko.observable('');
    that.DebitorNumber = ko.observable(0);
    that.Skonto = ko.observable(0);
    that.IsPrivateCustomerAddress = (pageModelHndl) ? ko.observable(pageModelHndl.IsPrivateCustomer) : ko.observable(false);
    that.Email = ko.observable('').extend({email: true});
    that.CommissionReceiverId = ko.observable();
    that.CommissionReceiver = ko.observable('');
    that.IsCountryUSA = ko.observable(false);
    that.PhoneNumber = ko.observable("");

    //subData
    that.Cities = ko.observableArray([]);
    that.CreditData = ko.observable();

    that.EditMode = ko.observable(false);

    that.AdditionalAddressInformation = ko.observable(new AdditionalAddressInformationModel());

    //flags
    that.IsChangeInProgress = ko.observable(false);
    that.IsVatIdValid = ko.observable(true);
    that.IsVatIdRecommended = ko.observable(false);
    that.IsVatCheckInProgress = ko.observable(false);
    that.ShowVat = ko.observable(false);
    that.IsStateProvinceCodeRequired = ko.observable(false);
    that.FirstNameHasError = ko.observable(false);
    that.LastNameHasError = ko.observable(false);
    that.CompanyHasError = ko.observable(false);
    that.PhoneNumberHasError = ko.observable(false);
    that.StateProvinceCodeHasError = ko.observable(false);
    that.StreetHasError = ko.observable(false);
    that.CityHasError = ko.observable(false);
    that.ZipCodeHasError = ko.observable(false);
    that.EmailVisible = ko.observable(false);
    that.EmailHasError = ko.observable(false);
    that.DebitorNumberHasError = ko.observable(false);
    
    
    that.CountryCaption = ko.computed(function () {
        if (!that.CountryId()) {
            return constants.OptionTexts.SelectCountryOption;
        }
    }, that);
    that.SalutationCaption = ko.computed(function () {
        if (!that.SalutationId()) {
            return constants.OptionTexts.SelectSalutationOption;
        }
    }, that);

    that.FirstNameProxy = ko.computed({
        read: function () {
            return that.FirstName();
        },
        write: function (newFirstName) {
            if (newFirstName.length + that.LastName().length <= 35 || that.EditMode()) {
                that.FirstName(newFirstName);
                that.FirstNameHasError(false);
            } else {
                that.FirstNameHasError(true);
                that.FirstNameProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });
    that.LastNameProxy = ko.computed({
        read: function () {
            return that.LastName();
        },
        write: function (newLastName) {
            if (newLastName.length + that.FirstName().length <= 35 || that.EditMode()) {
                that.LastName(newLastName);
                that.LastNameHasError(false);
            } else {
                that.LastNameHasError(true);
                that.LastNameProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });
    that.CompanyProxy = ko.computed({
        read: function () {
            return that.Company();
        },
        write: function (newCompany) {
            if (newCompany.length <= 100 || that.EditMode()) {
                that.Company(newCompany);
                that.CompanyHasError(false);
            } else {
                that.CompanyHasError(true);
                that.CompanyProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });

    that.CompanyDisplayProxy = ko.computed({
        read: function () {
            return that.Company().length > 35 ? that.Company().substr(0, 32) + '...' : that.Company();
        },
        write: function (newCompany) {
        },
        deferEvaluation: true,
        owner: that
    });

    that.PhoneNumberProxy = ko.computed({
        read: function () {
            return that.PhoneNumber();
        },
        write: function (newPhone) {
            var minLength = 1;
            if(that.IsCountryUSA()){
                minLength = 10;
            }
            if ((newPhone.length <= 19 && newPhone.length >= minLength) || that.EditMode()) {
                that.PhoneNumber(newPhone);
                that.PhoneNumberHasError(false);
            } else {
                that.PhoneNumberHasError(true);
                that.PhoneNumberProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });
    
    that.StreetProxy = ko.computed({
        read: function () {
            return that.Street();
        },
        write: function (newStreet) {
            if (newStreet.length <= 35 || that.EditMode()) {
                that.Street(newStreet);
                that.StreetHasError(false);
            } else {
                that.StreetHasError(true);
                that.StreetProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });
    
    that.CityProxy = ko.computed({
        read: function () {
            return that.City();
        },
        write: function (newCity) {
            if (newCity.length <= 30 || that.EditMode()) {
                that.City(newCity);
                that.CityHasError(false);
            } else {
                that.CityHasError(true);
                that.CityProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });
    
    that._ZipCodeProxy = ko.computed({
        read: function () {
            return that.ZipCode();
        },
        write: function (newZipCode) {
            if (newZipCode.length <= 9 || that.EditMode()) {
                that.ZipCode(newZipCode);
                that.ZipCodeHasError(false);
            } else {
                that.ZipCodeHasError(true);
                that._ZipCodeProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });
    
    that.StateProvinceCodeProxy = ko.computed({
        read: function () {
            return that.StateProvinceCode();
        },
        write: function (newStateProvinceCode) {
            if (newStateProvinceCode.length === 2 || that.EditMode()) {
                that.StateProvinceCode(newStateProvinceCode);
                that.StateProvinceCodeHasError(false);
            } else {
                that.StateProvinceCodeHasError(true);
                that.StateProvinceCode.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });

    that.EmailProxy = ko.computed({
        read: function () {
            return that.Email();
        },
        write: function (newEmail) {
            if (newEmail.length <= 50) {
                that.Email(newEmail);
                that.EmailHasError(false);
            } else {
                that.EmailHasError(true);
                that.EmailProxy.notifySubscribers();
            }
        },
        deferEvaluation: true,
        owner: that
    });
    
    that.DebitorNumberProxy = ko.computed({
        read: function () {
            return that.DebitorNumber();
        },
        write: function (newDebitorNumber) {
            if(newDebitorNumber >= 0) {
                that.DebitorNumber(newDebitorNumber)
                that.DebitorNumberHasError(false);
            } else {
                that.DebitorNumberHasError(true);
                that.DebitorNumber.notifySubscribers();
            }
        }
    });

    that.validate = function () {
        var valid = true;
        var models = [
            that.CountryId,
            that.FirstName,
            that.LastName,
            that.Street,
            that.ZipCode,
            that.City,
            that.StateProvinceCode,
            that.Email
        ];
        
        for (var i = 0; i < models.length; i++) {
            models[i].validate(models[i]());
            if (models[i].hasError()){
                valid = false;
            }
        }
        return valid;
    };

    //subscriptions
    that.VatId.subscribe(function (val) {
        if (val.length === 0) {
            that.IsVatIdValid(true);
            that.IsVatCheckInProgress(false);
            return;
        }

        var regexEuVatIds = /^(^$|(AT)U[0-9]{8}|(BE)0[0-9]{9}|(BG)[0-9]{9,10}|(CY)[0-9]{8}L|(CZ)[0-9]{8,10}|(DE)[0-9]{9}|(DK)[0-9]{8}|(EE)[0-9]{9}|(EL|GR)[0-9]{9}|(ES)[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)[0-9]{8}|(FR)[0-9A-Z]{2}[0-9]{9}|(GB)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)[0-9]{8}|(IE)[0-9]S[0-9]{5}L|(IT)[0-9]{11}|(LT)([0-9]{9}|[0-9]{12})|(LU)[0-9]{8}|(LV)[0-9]{11}|(MT)[0-9]{8}|(NL)[0-9]{9}B[0-9]{2}|(PL)[0-9]{10}|(PT)[0-9]{9}|(RO)[0-9]{2,10}|(SE)[0-9]{12}|(SI)[0-9]{8}|(SK)[0-9]{10})$/;
        if (regexEuVatIds.test(val)) {
            $.ajax({
                type: "POST",
                url: ajaxUrls.order.CheckVat,
                data: {vat: val}
            }).always(function (erg) {
                that.IsVatIdValid(erg.valid);
                that.IsVatCheckInProgress(false);
            }).fail(function () {
                alerts.error();
            });
        } else {
            that.IsVatIdValid(false);
            that.IsVatCheckInProgress(false);
        }
    }, this);

    that.CountryId.subscribe(function (val) {
        if (pageModelHndl && pageModelHndl.Countries) {
            var filterRequest = pageModelHndl.Countries().filter(function (country) {
                return country.CountryId() == val;
            });
            if (filterRequest[0]) {
                that.ISO(filterRequest[0].ISO());
                that.Country(filterRequest[0].CountryName());
                that.ShowVat(filterRequest[0].ISO() != pageModelHndl.DefaultCountryISO() && filterRequest[0].IsEU());
                that.IsStateProvinceCodeRequired(countryHasStateProvinceCode(filterRequest[0].CountryId()));
                that.IsCountryUSA(filterRequest[0].CountryId() === constants.countryIds.UnitedStates);
            }
        }
    }, that);

    that.SalutationId.subscribe(function (val) {
        if (pageModelHndl && pageModelHndl.Salutations) {
            var filterRequest = pageModelHndl.Salutations().filter(function (salutation) {
                return salutation.CountryId() == val;
            });
            if (filterRequest[0]) {
                that.Salutation(filterRequest[0].CountryName());
            }
        } else {
            that.Salutation($("#CustomAddressSalutation option:selected").text());
        }
    }, that);

    that.CommissionReceiverId.subscribe(function (val) {
        if (pageModelHndl && pageModelHndl.CommissionReceivers) {
            var filterRequest = pageModelHndl.CommissionReceivers().filter(function (commissionreceiver) {
                return commissionreceiver.CommissionReceiverId === val;
            });
            if (filterRequest[0]) {
                that.CommissionReceiver(filterRequest[0].CommissionReceiverName());
            }
        } else {
            that.CommissionReceiver($('#CustomCommissionReceiver option:selected').text());
        }
    }, that);

    //functions
    that.PopulateAddressModel = function (address) {
        if (address) {
            that.AddressId(address.AddressId);
            that.IsPrivateCustomerAddress(address.IsPrivateCustomerAddress);
            that.SalutationId(address.SalutationId);
            that.CountryId(address.CountryId);
            that.Country(address.Country);
            that.StateProvinceCode(address.StateProvinceCode);
            that.CommissionReceiverId(address.CommissionReceiverId);

            that.ZipCode(address.ZipCode ? address.ZipCode : '');
            that.Country(address.Country ? address.Country : '');
            that.PhoneNumber(address.PhoneNumber ? address.PhoneNumber : '');


            that.AdditionalAddressInformation(new AdditionalAddressInformationModel());
            that.AdditionalAddressInformation().Populate(address);

            that.Skonto(address.Skonto);

            if (address.Salutation) {
                that.Salutation(address.Salutation);
            } else {
                that.Salutation('');
            }

            if (address.CommissionReceiver) {
                that.CommissionReceiver(address.CommissionReceiver);
            } else {
                that.CommissionReceiver('');
            }

            if (address.Company) {
                that.Company(address.Company);
            }

            if (address.FirstName) {
                that.FirstName(address.FirstName);
            }

            if (address.LastName) {
                that.LastName(address.LastName);
            }

            if (address.Street) {
                that.Street(address.Street);
            }

            if (address.VatId) {
                that.VatId(address.VatId);
            }

            if (address.City) {
                that.City(address.City);
            }

            if (address.CMwSt !== undefined && address.CMwSt != null) {
                that.CMwSt(address.CMwSt);
            }

            if (address.DebitorNumber && address.DebitorNumber > 0) {
                that.DebitorNumber(address.DebitorNumber);
            }

            if (address.Email) {
                that.Email(address.Email);
            }

            if (countryHasStateProvinceCode(address.CountryId)) {
                that.IsStateProvinceCodeRequired(true);
                
                if(address.CountryId === constants.countryIds.UnitedStates){
                    that.IsCountryUSA(true);
                }
            } else {
                that.IsCountryUSA(false);
                that.IsStateProvinceCodeRequired(false);
            }

            if (address.IsEuCountry !== undefined) {
                that.ShowVat(address.IsEuCountry);
            } else {
                $.ajax({
                    type: "GET",
                    url: ajaxUrls.area.ajax.country.IsEuCountry,
                    data: {id: address.CountryId}
                }).done(function (isEu) {
                    that.ShowVat(isEu);
                }).fail(function () {
                    alerts.error();
                });
            }
        }
    };
};

shop.models.AddressModel = AddressModel;

var CreditCardModel = function (pageModelHndl) {
    var that = this;

    //baseData
    that.CreditCardOwner = ko.observable('');
    that.CreditCardNumber = ko.observable('');
    that.CreditInstituteCode = ko.observable('');
    that.CreditInstituteName = ko.observable('');
    that.CreditIban = ko.observable('');
    that.CreditBic = ko.observable('');
    that.EditHasError = ko.observable(false);

    //proxy
    that.CreditCardNumberHasError = ko.observable(false);
    that.CreditCardNumberProxy = ko.computed({
        read: function () {
            return that.CreditCardNumber();
        },
        write: function (value) {
            that.CreditCardNumber(value);
            if (value.match(/^[0-9]*$|^$/)) {
                that.CreditCardNumberHasError(false);
            } else {
                that.CreditCardNumberHasError(true);
            }
        },
        deferEvaluation: false,
        owner: that
    });

    that.CreditInstituteCodeHasError = ko.observable(false);
    that.CreditInstituteCodeProxy = ko.computed({
        read: function () {
            return that.CreditInstituteCode();
        },
        write: function (value) {
            that.CreditInstituteCode(value);
            if (value.match(/^[0-9]*$|^$/)) {
                that.CreditInstituteCodeHasError(false);
            } else {
                that.CreditInstituteCodeHasError(true);
            }
        },
        deferEvaluation: false,
        owner: that
    });

    that.CreditIbanHasError = ko.observable(false);
    that.CreditIbanProxy = ko.computed({
        read: function () {
            return that.CreditIban();
        },
        write: function (value) {
            that.CreditIban(value);
            that.EditHasError(false);
            if (value !== "") {
                that.CreditIbanHasError(!IBAN.isValid(value));
            }
        },
        deferEvaluation: false,
        owner: that
    });

    that.CreditBicHasError = ko.observable(false);
    that.CreditBicProxy = ko.computed({
        read: function () {
            return that.CreditBic();
        },
        write: function (value) {
            that.CreditBic(value);
            that.EditHasError(false);
            if (value !== "") {
                that.CreditBicHasError(!BIC.isValid(value));
            }
        },
        deferEvaluation: false,
        owner: that
    });

    that.evaluateIban = function (e, args) {
        var value = args.currentTarget.value;
        if (value.length >= 15) {
            that.CreditIbanHasError(!IBAN.isValid(value));
        } else {
            that.CreditIbanHasError(true);
        }
    };

    that.evaluateBic = function (e, args) {
        var value = args.currentTarget.value;
        if (value.length >= 8) {
            that.CreditBicHasError(!BIC.isValid(value));
        } else {
            that.CreditBicHasError(true);
        }
    };

    //functions
    that.PopulateCreditCardModel = function (bankAccount) {
        that.CreditCardNumberHasError(false);
        that.CreditInstituteCodeHasError(false);
        that.CreditIbanHasError(false);
        that.CreditBicHasError(false);

        that.CreditCardOwner(bankAccount.AccountOwner);
        that.CreditCardNumber(bankAccount.AccountNumber);
        that.CreditInstituteCode(bankAccount.BankCode);
        that.CreditInstituteName(bankAccount.BankName);
        that.CreditIban(bankAccount.Iban);
        that.CreditBic(bankAccount.Bic);

        that.checkBankAccount();
    };

    // This must be set to "null" and will be changed after the "CheckBankAccount" ajax call.
    that.IsValid = ko.observable(null);
    that.IsIncomplete = ko.observable(false);

    that.validate = ko.computed(function () {
        // Minimum length to execute the ajax call.
        if (that.CreditIban().length >= 10 && that.CreditBic().length > 6) {
            if ($('input[name=PAYMENT]:checked').val() != 'DIRECT_DEBIT') {
                return true;
            }

            that.checkBankAccount();
            return true;
        }

        return false;
    }, that);

    that.checkBankAccount = function () {
        $.ajax({
            type: "POST",
            url: ajaxUrls.shoppingCart.CheckBankAccount,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: ko.toJSON(ko.mapping.fromJS({iban: that.CreditIban(), bic: that.CreditBic()})),
            success: function (result) {
                that.IsValid(result.Success);
                if (result.BankOK) {
                    that.IsIncomplete(false);
                } else {
                    that.CreditInstituteName("");
                }
            }
        }).fail(function () {
            alerts.error();
        });
    };
};

var AddressCreditDataModel = function (pageModelHndl) {
    var that = this;
    ko.utils.extend(that, new CreditCardModel());

    that.AddressId = ko.observable();
    that.BankAccountId = ko.observable();
    that.CreditCardDataToEditHasError = ko.observable(false);
    that.CreditCardDataToEditErrorMessage = ko.observable('');

    that.IsSaving = ko.observable(false);

    that.GetBankAccountByAddressOrderReference = function (orderReference) {
        $.get(ajaxUrls.shoppingCart.GetBankAccountByOrderReference, {orderReference: orderReference}, function (data) {
            if (data.Success) {
                that.PopulateCreditCardModel(data.BankAccount);
            }
            that.AddressId(data.AddressId);
            that.BankAccountId(data.BankAccount.BankAccountId);
        }).fail(function () {
            alerts.error();
        });
    };

    that.GetBankAccountByAddressId = function (addressId) {
        $.get(ajaxUrls.shoppingCart.GetBankAccountByAddressId, {id: addressId}, function (data) {
            if (data.Success) {
                that.PopulateCreditCardModel(data.BankAccount);
                that.BankAccountId(data.BankAccount.BankAccountId);
            }
            that.AddressId(addressId);
        }).fail(function () {
            alerts.error();
        });
    };

    that.SaveCreditDataChanges = function () {
        var bankAccountIndicator = $("#BankAccountIndicator");
        if (that.CreditIban() === "" || that.CreditBic() === "") {
            that.EditHasError(true);
            bankAccountIndicator
                .removeClass("ErrorIcon")
                .removeClass("Loading")
                .removeClass("ValidIcon");
            bankAccountIndicator.show();
            bankAccountIndicator.css('display', 'inline-block');
            return false;
        } else {
            that.EditHasError(false);
            bankAccountIndicator
                .removeClass("ValidIcon")
                .removeClass("ErrorIcon")
                .addClass("Loading");

            bankAccountIndicator.show();
            bankAccountIndicator.css('display', 'inline-block');
        }

        that.SaveBankAccount(function () {
            bankAccountIndicator.removeClass("Loading").addClass("ValidIcon");
            bankAccountIndicator.css('display', 'inline-block');
        }, function () {
            bankAccountIndicator.removeClass("Loading").addClass("ErrorIcon");
            bankAccountIndicator.css('display', 'inline-block');
        });
    };

    that.SaveBankAccount = function (successCallback, failureCallback) {
        that.IsSaving(true);
        $.post(ajaxUrls.shoppingCart.SetBankAccountForAddressId, {
            addressId: that.AddressId(),
            iban: that.CreditIban(),
            bic: that.CreditBic(),
            owner: that.CreditCardOwner()
        }, function (data) {
            that.IsSaving(false);
            if (data.Success) {
                successCallback();
            } else {
                failureCallback();
            }
        }).fail(function () {
            alerts.error();
        });
    };

    that.SaveOrderBankAccount = function (successCallback, failureCallback) {
        that.IsSaving(true);
        $.post(ajaxUrls.shoppingCart.SetBankAccountForOrder, {
            bankAccountId: that.BankAccountId(),
            iban: that.CreditIban(),
            bic: that.CreditBic(),
            owner: that.CreditCardOwner()
        }, function (data) {
            that.IsSaving(false);
            if (data.Success) {
                successCallback(that, data);
            } else {
                failureCallback(that, data);
            }
        }).fail(function () {
            alerts.error();
        });
    };
};

var BillPayModel = function (pageModelHndl) {
    var that = this;
    that.UserAgreesToTerms = ko.observable(false);
    that.IsValidating = ko.observable(false);
    that.BirthdayHasError = ko.observable(false);
    that.BillPayOptionNetPrice = ko.observable(0);
    that.BillPayOptionGrossPrice = ko.observable(2);
    that.BillPayOptionVatAmount = ko.computed(function () {
        return that.BillPayOptionGrossPrice() - that.BillPayOptionNetPrice();
    });

    that.ValidBillPayCountries = ko.observableArray([]);

    that.MaxYearForBirthday = ko.computed(function () {
        var now = new Date();
        return new Date(now.getFullYear() - 18, now.getMonth(), now.getDate());
    });

    that.LegalFormCollection = ko.observableArray([]);

    that.FilteredLegalFormCollection = ko.computed(function () {

        var staticAvailableIdMap = [];
        var result = [];

        if (!pageModelHndl.IsPrivateCustomer()) {
            if (pageModelHndl.InvoiceAddress() !== undefined) {

                switch (pageModelHndl.InvoiceAddress().Country().CountryId()) {
                    case 2: //Deutschland
                        //ag, eg, ek, ev, freelancer, gbr, gmbh, gmbh_ig, gmbh_co_kg, kg, kgaa, ltd, ltd_co_kg, ohg, public_inst, misc_capital, misc, foundation, ug
                        staticAvailableIdMap = [1, 2, 4, 6, 7, 8, 9, 10, 11, 12, 14, 15, 17, 18, 19, 20, 21, 22, 23];
                        break;
                    case 5: //Schweiz
                        //ag, eg, einzel, e_ges, ev, freelancer, gmbh, inv_kk, kg, kgaa, k_ges, ltd, public_inst, misc_capital, misc, foundation
                        staticAvailableIdMap = [1, 2, 3, 5, 6, 7, 9, 12, 13, 14, 15, 16, 19, 20, 21, 22];
                        break;
                    default:
                        break;
                }

                ko.utils.arrayForEach(that.LegalFormCollection(), function (item) {
                    if (staticAvailableIdMap.indexOf(item.LegalFormId) > -1) {
                        result.push(item);
                    }
                });
            }
        }
        return result;
    });

    that.BillPayErrors = ko.observableArray([]);

    //Data for hints in shoppingcart page 3
    that.BillPayAvailableForCountry = ko.observable(false);

    //Validierung für Fehleranzeige
    that.ValidateClient = function () {

        if (!that.UserAgreesToTerms()) {
            that.BillPayErrors.push("Sie müssen die AGB von BillPay akzeptieren.");
        }

        //Validierung Firmenkunden
        if (!pageModelHndl.IsPrivateCustomer()) {
            if (that.IsHolderNameRequired()) {
                if (!(pageModelHndl.InvoiceAddress().AdditionalAddressInformation().HolderName())) {
                    that.BillPayErrors.push("Bitte ergänzen Sie den Namen des Inhabers.");
                }
            }

            if (that.IsRegisterNumberRequired()) {
                if (!(pageModelHndl.InvoiceAddress().AdditionalAddressInformation().RegisterNumber())) {
                    that.BillPayErrors.push("Bitte ergänzen Sie die Handelsregisternummer.");
                }
            }

            if (!(pageModelHndl.InvoiceAddress().Company())) {
                that.BillPayErrors.push("Bitte ergänzen Sie den Firmennamen.");
            }
        }

        //Validierung Privatkunden
        if (pageModelHndl.IsPrivateCustomer()) {
            if (!pageModelHndl.InvoiceAddress().AdditionalAddressInformation()) {
                that.BillPayErrors.push("Bitte ergänzen Sie das Geburtsdatum.");
            }
        }

        return (that.BillPayErrors().length === 0);
    };

    that.IsHolderNameRequired = ko.computed(function () {
        var staticRequireIdMap = [];

        if (!pageModelHndl.IsPrivateCustomer()) {
            if (pageModelHndl.InvoiceAddress() !== undefined) {

                switch (pageModelHndl.InvoiceAddress().Country().CountryId()) {
                    case 2: //Deutschland
                        staticRequireIdMap = [7, 8]; //freelancer, gbr
                        break;
                    case 5: //Schweiz
                        staticRequireIdMap = [3, 5, 7, 15]; //einzel, e-ges, freelancer, k_ges
                        break;
                    default:
                        break;
                }
                return pageModelHndl.InvoiceAddress().AdditionalAddressInformation()
                    && (staticRequireIdMap.indexOf(pageModelHndl.InvoiceAddress().AdditionalAddressInformation().LegalFormId()) > -1);
            }
        }
        return false;
    });

    that.IsRegisterNumberRequired = ko.computed(function () {

        var staticRequireIdMap = [];

        if (!pageModelHndl.IsPrivateCustomer()) {
            if (pageModelHndl.InvoiceAddress() !== undefined) {
                switch (pageModelHndl.InvoiceAddress().Country().CountryId()) {
                    case 2: //Deutschland
                        staticRequireIdMap = [1, 4, 9, 11, 13, 17, 18, 23]; //ag, ek, gmbh, gmbh_co_kg, kg,ltd_co_kg, ohg, ug
                        break;
                    case 5: //Schweiz
                        staticRequireIdMap = [1, 2, 9, 13, 14, 22]; //ag, eg, gmbh, kg, kgaa, foundation
                        break;
                    default:
                        break;
                }

                return pageModelHndl.InvoiceAddress().AdditionalAddressInformation()
                    && (staticRequireIdMap.indexOf(pageModelHndl.InvoiceAddress().AdditionalAddressInformation().LegalFormId()) > -1);
            }
        }

        return false;
    });
};

var LegalFormModel = function (name, id, displayText) {
    var that = this;
    that.LegalFormName = name;
    that.LegalFormId = id;
    that.LegalFormDisplayText = displayText;
};

var AdditionalAddressInformationModel = function () {
    var that = this;
    that.HolderName = ko.observable();
    that.RegisterNumber = ko.observable();
    that.Birthday = ko.observable();
    that.LegalFormId = ko.observable(-1);
    that.LongBirthdayDate = ko.observable();

    that.Populate = function (parentAddress) {
        if (parentAddress && parentAddress.AdditionalAddressInformation) {
            if (parentAddress.AdditionalAddressInformation.LegalForm) {
                that.LegalFormId(parentAddress.AdditionalAddressInformation.LegalForm.LegalFormId);
            }

            if (parentAddress.AdditionalAddressInformation.HolderName) {
                that.HolderName(parentAddress.AdditionalAddressInformation.HolderName);
            }

            if (parentAddress.AdditionalAddressInformation.RegisterNumber) {
                that.RegisterNumber(parentAddress.AdditionalAddressInformation.RegisterNumber);
            }

            if (parentAddress.AdditionalAddressInformation.LongBirthdayDate && (parentAddress.AdditionalAddressInformation.LongBirthdayDate !== -1)) {
                that.Birthday(new Date(parentAddress.AdditionalAddressInformation.LongBirthdayDate));
                that.LongBirthdayDate(parentAddress.AdditionalAddressInformation.LongBirthdayDate);
            }
        }
    };
};
